import axios from "axios";
import { ServerPath } from "../Constant/index";

const url = process.env.NODE_ENV === "production" 
  ? `${ServerPath}/api` 
  : ServerPath;

export const _axios = axios.create({ baseURL: url });

/**
 * Request Interceptor
 * Standardizes header injection for both JWT and Session tokens.
 */
_axios.interceptors.request.use(
  (config) => {
    // 1. Handle JWT Authorization (Stored during login)
    const token = localStorage.getItem("Token");
    if (token) {
      // Your middleware uses split(" ")[1], so we must use the 'Bearer ' prefix
      config.headers.Authorization = `Bearer ${token}`;
    }

    // 2. Handle Session Tokens (Used for public/pre-login paths like OTP)
    const sessionToken = localStorage.getItem("SessionToken");
    if (sessionToken) {
      // Matches the key expected by your middleware: req.headers["x-session-token"]
      config.headers["x-session-token"] = sessionToken;
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Response Interceptor
 */
_axios.interceptors.response.use(
  (response) => {
    // Check for "Access Denied" messages often sent in your 200 responses
    if (response.data && response.data.success === 0 && response.data.message === 'Access Denied!') {
      handleSessionExpiry();
    }
    return response;
  },
  (error) => {
    // 401: Unauthorized (Invalid Token) 
    // 403: Forbidden (Missing Token)
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      handleSessionExpiry();
    }
    return Promise.reject(error);
  }
);

const handleSessionExpiry = () => {
  localStorage.removeItem("Token");
  localStorage.removeItem("Name");
  // Redirect to login using vanilla JS since this is outside the React tree
  if (window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
};